import { InfoCircleOutlined } from "@ant-design/icons";
import { Popover, Typography } from "antd";
import classNames from "classnames";
import PropTypes from "prop-types";

import { TranslateCost } from "@/modules/translate";

import { ProjectCostItemType } from "./ProjectCostsCard.type";

const { Text } = Typography;

const ProjectCostLine = ({ name, value, color, subCosts, textsClassName }) => {
  return (
    <>
      <Text ellipsis className={classNames("title", textsClassName)}>
        {subCosts?.length > 0 && (
          <Popover
            title={name}
            content={
              <div className="project-costs-card-grid">
                {subCosts.map((cost) => (
                  <ProjectCostLine
                    key={`${cost.name}-${cost.value}`}
                    {...cost}
                  />
                ))}
              </div>
            }
          >
            <InfoCircleOutlined />
          </Popover>
        )}
        {name}
      </Text>
      <div className="chip-color" style={{ backgroundColor: color }} />
      <Text className={classNames("cost", textsClassName)}>
        <TranslateCost value={value} />
      </Text>
    </>
  );
};

ProjectCostLine.propTypes = {
  ...ProjectCostItemType,
  subCosts: PropTypes.arrayOf(PropTypes.shape(ProjectCostItemType)),
  textsClassName: PropTypes.string,
};

export default ProjectCostLine;
